(function () {
  const STOREFRONT_TOKEN = '3b017797bd3cad1e9a4b8bd490533799';
  const API_URL = `https://${Shopify.shop}/api/2025-01/graphql.json`;

  let lastVariantId = null;

  async function fetchLocationInventory(variantId) {
    const gid = `gid://shopify/ProductVariant/${variantId}`;
    const query = `{
      node(id: "${gid}") {
        ... on ProductVariant {
          storeAvailability(first: 30) {
            edges {
              node {
                available
                quantityAvailable
                location { name }
              }
            }
          }
        }
      }
    }`;

    const resp = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    const json = await resp.json();

    if (json.errors) {
      console.warn('[location-inventory] GraphQL errors:', json.errors);
      return [];
    }

    return json?.data?.node?.storeAvailability?.edges ?? [];
  }

  function applyInventory(levels) {
    document.querySelectorAll('.pickup-avail-card').forEach((card) => {
      const nameEl = card.querySelector('.pickup-avail-card__name');
      if (!nameEl) return;

      const locationName = nameEl.textContent.trim();
      const match = levels.find((e) => e.node.location.name === locationName);
      if (!match) return;

      const qty = match.node.quantityAvailable;
      const stockEl = card.querySelector('.pickup-avail-card__stock');
      if (!stockEl) return;

      const dotClass = qty > 0 ? 'pickup-avail-card__dot--in' : 'pickup-avail-card__dot--out';
      const label = qty > 0 ? `${qty} in stock` : 'Sold Out';
      stockEl.innerHTML = `<span class="pickup-avail-card__dot ${dotClass}"></span> ${label}`;
      card.classList.toggle('pickup-avail-card--unavailable', qty <= 0);
    });
  }

  async function update(variantId) {
    if (!variantId) return;
    lastVariantId = variantId;
    try {
      const levels = await fetchLocationInventory(variantId);
      if (lastVariantId === variantId) applyInventory(levels);
    } catch (e) {
      console.warn('[location-inventory] error:', e);
    }
  }

  function getCurrentVariantId() {
    const selectors = [
      'form[action*="/cart/add"] input[name="id"]',
      '#ProductForm input[name="id"]',
      'input[name="id"][form*="product-form"]',
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el?.value) return el.value;
    }
    return null;
  }

  function watchPickupSection() {
    const el = document.querySelector('pickup-availability');
    if (!el) return;

    let debounce;
    new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const id = getCurrentVariantId();
        if (id) update(id);
      }, 100);
    }).observe(el, { childList: true });
  }

  // ── Update "Color: [name]" label on swatch click ─────────────────────────
  function initSelectedValueUpdater() {
    document.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.matches('.product-form__input--swatch input[type="radio"]')) return;
      const fieldset = input.closest('fieldset');
      if (!fieldset) return;
      const span = fieldset.querySelector('[data-selected-value]');
      if (span) span.textContent = input.value;
    });
  }

  function init() {
    const id = getCurrentVariantId();
    if (id) update(id);

    watchPickupSection();
    initSelectedValueUpdater();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variantId = event?.data?.variant?.id;
        if (variantId) update(String(variantId));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
